(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-ribbon"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hewn-promo-ribbon')) {
    class HewnPromoRibbon extends HTMLElement {
      constructor() {
        super();
        this.onDismiss = this.dismiss.bind(this);
        this.onPageShow = this.checkExpiry.bind(this);
        this.onVisibility = () => { if (!document.hidden) this.checkExpiry(); };
      }

      connectedCallback() {
        if (this.connected) return;
        this.connected = true;
        this.key = 'hewn:promo-ribbon:' + (this.dataset.campaignId || 'bf-2026');
        this.expiresAt = this.parseExpiry(this.dataset.endsAt || '');
        this.closeButton = this.querySelector('.promo-ribbon__close');
        this.closeButton?.addEventListener('click', this.onDismiss);
        window.addEventListener('pageshow', this.onPageShow);
        document.addEventListener('visibilitychange', this.onVisibility);
        let dismissed = false;
        try {
          dismissed = window.sessionStorage.getItem(this.key) === 'dismissed';
        } catch (_) {
          // An unavailable storage area must not suppress the promotion.
        }
        this.hidden = dismissed || (this.expiresAt !== null && this.expiresAt <= Date.now());
        this.inert = this.hidden;
        this.removeAttribute('aria-hidden');
        this.classList.remove('is-closing');
        this.style.removeProperty('height');
        this.style.removeProperty('opacity');
        this.closing = false;
        const countdown = this.querySelector('[data-promo-countdown]');
        if (countdown) {
          countdown.hidden = true;
          countdown.textContent = '';
          if (!this.hidden && this.dataset.showCountdown === 'true' && this.expiresAt !== null) {
            const days = Math.ceil((this.expiresAt - Date.now()) / 86400000);
            if (days > 0) {
              const hasMeta = Boolean(this.querySelector('.promo-ribbon__meta-copy')?.textContent.trim());
              countdown.textContent = (hasMeta ? ' · ' : '') + 'Ends in ' + days + (days === 1 ? ' day' : ' days');
              countdown.hidden = false;
            }
          }
        }
        if (!this.hidden) this.scheduleExpiry();
      }

      disconnectedCallback() {
        this.closeButton?.removeEventListener('click', this.onDismiss);
        window.removeEventListener('pageshow', this.onPageShow);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.cancelAnimationFrame(this.frame);
        window.clearTimeout(this.collapseTimer);
        window.clearTimeout(this.expiryTimer);
        this.connected = false;
      }

      parseExpiry(value) {
        const input = value.trim();
        if (!input) return null;
        // Date-only settings mean the end of that date in UTC on every device.
        const match = input.match(/^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,3}))?)?(Z|[+-]\d{2}:\d{2}))?$/);
        if (!match) return null;
        const [, year, month, day, hour, minute, second, , zone] = match;
        const calendar = new Date(year + '-' + month + '-' + day + 'T00:00:00Z');
        if (!Number.isFinite(calendar.getTime()) || calendar.getUTCFullYear() !== Number(year) || calendar.getUTCMonth() + 1 !== Number(month) || calendar.getUTCDate() !== Number(day)) return null;
        if (hour !== undefined && (Number(hour) > 23 || Number(minute) > 59 || Number(second || 0) > 59)) return null;
        if (zone && zone !== 'Z' && (Number(zone.slice(1, 3)) > 23 || Number(zone.slice(4, 6)) > 59)) return null;
        const timestamp = Date.parse(hour === undefined ? input + 'T23:59:59.999Z' : input);
        return Number.isFinite(timestamp) ? timestamp : null;
      }

      checkExpiry() {
        if (this.hidden || this.expiresAt === null) return;
        if (this.expiresAt <= Date.now()) this.hide();
        else this.scheduleExpiry();
      }

      scheduleExpiry() {
        window.clearTimeout(this.expiryTimer);
        if (this.hidden || this.expiresAt === null) return;
        const remaining = this.expiresAt - Date.now();
        if (remaining <= 0) {
          this.hide();
          return;
        }
        // Long campaigns rearm at the browser's safe timeout limit; no interval.
        this.expiryTimer = window.setTimeout(() => this.checkExpiry(), Math.min(remaining, 2147483647));
      }

      moveFocusForward() {
        if (!this.contains(document.activeElement)) return;
        let section = this.closest('.shopify-section')?.nextElementSibling;
        while (section) {
          const targets = section.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]');
          const next = Array.from(targets).find((element) => element.getClientRects().length && !element.closest('[hidden], [inert]'));
          if (next) {
            next.focus({ preventScroll: true });
            return;
          }
          section = section.nextElementSibling;
        }
      }

      dismiss() {
        if (this.hidden || this.closing) return;
        try {
          window.sessionStorage.setItem(this.key, 'dismissed');
        } catch (_) {
          // The current page can still dismiss when persistence is unavailable.
        }
        this.moveFocusForward();
        if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
          this.hide();
          return;
        }
        this.closing = true;
        this.style.height = this.getBoundingClientRect().height + 'px';
        this.classList.add('is-closing');
        this.inert = true;
        this.setAttribute('aria-hidden', 'true');
        this.getBoundingClientRect();
        this.frame = window.requestAnimationFrame(() => {
          this.style.height = '0px';
          this.style.opacity = '0';
          this.collapseTimer = window.setTimeout(() => this.hide(), 240);
        });
      }

      hide() {
        this.moveFocusForward();
        window.cancelAnimationFrame(this.frame);
        window.clearTimeout(this.collapseTimer);
        window.clearTimeout(this.expiryTimer);
        this.hidden = true;
        this.inert = true;
        this.closing = false;
        this.classList.remove('is-closing');
        this.style.removeProperty('height');
        this.style.removeProperty('opacity');
      }
    }
    customElements.define('hewn-promo-ribbon', HewnPromoRibbon);
  }

  } catch(e) { console.error(e); }
})();
})();
